import AllActions from "@/infrastructure/rootAction";
import produce from "immer";
import { getType } from "typesafe-actions";
import * as A from "./actions";
import { defaultState } from "./defaults";

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.updateSelectedTicker):
        draft.selectedTicker = action.payload;
        break;

      case getType(A.updateIsBuy):
        draft.isBuy = action.payload;
        break;

      case getType(A.deletePortfolio.request):
        draft.status.delete = "REQUEST";
        break;
      case getType(A.deletePortfolio.failure):
        draft.status.delete = "FAILURE";
        break;
      case getType(A.deletePortfolio.success):
        draft.status.delete = "SUCCESS";
        break;

      case getType(A.fetchTradeMeta.request):
        draft.status.meta = "REQUEST";
        break;
      case getType(A.fetchTradeMeta.failure):
        draft.status.meta = "FAILURE";
        break;
      case getType(A.fetchTradeMeta.success):
        draft.status.meta = "SUCCESS";
        draft.meta = action.payload;
        break;

      case getType(A.findTickers.request):
        draft.status.tickers = "REQUEST";
        break;
      case getType(A.findTickers.failure):
        draft.status.tickers = "FAILURE";
        break;
      case getType(A.findTickers.success):
        draft.status.tickers = "SUCCESS";
        draft.tickers = action.payload;
        break;

      case getType(A.fetchTickerSummary.request):
        draft.status.tickerSummary = "REQUEST";
        break;
      case getType(A.fetchTickerSummary.failure):
        draft.status.tickerSummary = "FAILURE";
        break;
      case getType(A.fetchTickerSummary.success):
        draft.status.tickerSummary = "SUCCESS";
        draft.tickerSummary = action.payload;
        break;

      case getType(A.fetchPortfolioMetrics.request):
        draft.status.metrics = "REQUEST";
        break;
      case getType(A.fetchPortfolioMetrics.failure):
        draft.status.metrics = "FAILURE";
        break;
      case getType(A.fetchPortfolioMetrics.success):
        draft.status.metrics = "SUCCESS";
        draft.metrics = [...state.metrics.filter(e => e.portfolioId !== action.payload.portfolioId), action.payload];
        break;

      case getType(A.performTrade.request):
        draft.status.trade = "REQUEST";
        break;
      case getType(A.performTrade.failure):
        draft.status.trade = "FAILURE";
        break;
      case getType(A.performTrade.success):
        draft.status.trade = "SUCCESS";
        break;
    }
  });
